import { expectEl, Unsubs } from "./util";

const MIN = 0.5;
const ACCELERATION = 0.5;
const DECELERATION = 1;
const MAX_VELOCITY = 50;

interface RotateState {
    velocity: number;
    el: HTMLElement | null;
    isRunning: boolean;
}

const STATE: RotateState = {
    velocity: 0,
    el: null,
    isRunning: false,
};

export function setupRotateFor(query = "h1") {
    const unsubs = new Unsubs();

    STATE.el = expectEl(query);

    const lastPos: { x: number | null; y: number | null } = {
        x: null,
        y: null,
    };

    const onmove = (event: MouseEvent | TouchEvent) => {
        const bodyRect = document.body.getBoundingClientRect();
        const center = {
            x: Math.floor(bodyRect.width * 0.5),
            y: Math.floor(bodyRect.height * 0.5),
        };

        const ev = "changedTouches" in event ? event.changedTouches[0] : event;

        if (!ev) return;

        const mouse = {
            x: ev.clientX,
            y: ev.clientY,
        };

        if (lastPos.x === null) {
            lastPos.x = mouse.x;
        }
        if (lastPos.y === null) {
            lastPos.y = mouse.y;
        }

        const movement = {
            x: mouse.x - lastPos.x,
            y: mouse.y - lastPos.y,
        };

        lastPos.x = mouse.x;
        lastPos.y = mouse.y;

        const axis = Math.abs(movement.x) > Math.abs(movement.y) ? "x" : "y";

        const n = movement[axis];

        if (n < MIN && n > -MIN) return;

        //const sign = (n > MIN || n < -MIN) ? (Math.sign(n) * Math.sign(mouse[axis] - center[axis])) : 0;
        const sign =
            axis === "x"
                ? Math.sign(n) * Math.sign(center.y - mouse.y)
                : Math.sign(n) * Math.sign(mouse.x - center.x);

        const delta = ACCELERATION * (Math.abs(n) * 0.05) * sign;

        STATE.velocity += delta;

        // el.style.rotate = `${(Number.parseInt(el.style.rotate) || 0) + delta}deg`;
    };

    const resetLastPos = () => {
        lastPos.x = null;
        lastPos.y = null;
    };

    document.addEventListener("mousemove", onmove);
    document.addEventListener("touchmove", onmove);
    document.addEventListener("touchend", resetLastPos);

    STATE.isRunning = true;

    unsubs
        .add(() => document.removeEventListener("mousemove", onmove))
        .add(() => document.removeEventListener("touchmove", onmove))
        .add(() => document.removeEventListener("touchend", resetLastPos))
        .add(() => (STATE.isRunning = false));

    update();

    return unsubs;
}

function update() {
    if (!STATE.isRunning || !STATE.el) return;

    STATE.velocity = Math.max(
        Math.min(
            Math.sign(STATE.velocity) > 0
                ? Math.max(STATE.velocity - DECELERATION, 0)
                : Math.min(STATE.velocity + DECELERATION, 0),
            MAX_VELOCITY,
        ),
        -MAX_VELOCITY,
    );

    if (Math.abs(STATE.velocity) > 0) {
        const deg =
            ((Number.parseInt(STATE.el.style.rotate) || 0) + STATE.velocity) %
            360;
        STATE.el.style.rotate = `${deg}deg`;
        STATE.el.style.scale = (
            1 +
            Math.abs(STATE.velocity) / MAX_VELOCITY
        ).toFixed(3);
    }

    window.requestAnimationFrame(update);
}
